import { localisedValue } from "utils"

const teamTypeTransformer = (response, args) => {
  return response?.map(item => ({ ...item, value: !!args?.transformKey ? item.id + "" : item.key , label: localisedValue({object:item, key:"name"})}))
}

export default teamTypeTransformer
